import { ProductModel } from '../../product/models/ProductModel';
import { SubscriberModel } from '../../subscriber/models/SubscriberModel';

interface BillingCreationMonth {
    enum: string,
    description: string,
}

interface BillingCreationDate {
    month: {
        enum: string,
        description: string,
    },
    year: number,
}

interface BillingCreation {
    date: string;
    idProduct?: string;
    idSubscriber?: string;
}

export class BillingCreationModel {
    static getAvailableMonths():BillingCreationMonth[] {
        return [
            {enum: '01', description: 'Janeiro'},
            {enum: '02', description: 'Fevereiro'},
            {enum: '03', description: 'Março'},
            {enum: '04', description: 'Abril'},
            {enum: '05', description: 'Maio'},
            {enum: '06', description: 'Junho'},
            {enum: '07', description: 'Julho'},
            {enum: '08', description: 'Agosto'},
            {enum: '09', description: 'Setembro'},
            {enum: '10', description: 'Outubro'},
            {enum: '11', description: 'Novembro'},
            {enum: '12', description: 'Dezembro'},
        ]
    }

    date: BillingCreationDate = {
        month: {
            enum: '01',
            description: 'Janeiro'
        },
        year: new Date().getFullYear(),
    }
    product?: ProductModel
    subscriber?: SubscriberModel

    constructor(b?:Partial<BillingCreationModel>) {
        Object.assign(this, b)
    }

    isValid():boolean {
        return !!this.date?.month &&
               !!this.date?.month?.enum &&
               !!this.date?.year &&
               ((this.date?.year > (new Date().getFullYear() - 3)) && (this.date?.year < (new Date().getFullYear() + 3)))
    }

    getInformationFormatted():BillingCreation {
        return {
            date: `${this.date.year}-${this.date.month.enum}-01`, 
            idProduct: this.product?.id,
            idSubscriber: this.subscriber?.id,
        }
    }
}

